<template>
  <div>
    <div class="px-6 md:px-16 pb-10 pt-4 text-zt-lg" :class="primaryTextClass">
      <div v-if="someLicenseExpired" class="pb-4">
        <v-alert type="warning" outline v-if="daysExpired > 0" :value="true">{{
          $t(
            'message.LincensesApprovalPendingComponent.modal.singleRejectExpired',
            { days: daysExpired }
          )
        }}</v-alert>
        <v-alert type="warning" outline v-else :value="true">{{
          $t(
            'message.LincensesApprovalPendingComponent.modal.massiveRejectExpired'
          )
        }}</v-alert>
      </div>
      <v-textarea
        :color="primaryColor"
        v-model="observations"
        :label="
          $t(
            'message.LincensesApprovalPendingComponent.modal.observationsPlaceholder'
          )
        "
        class="fieldPasswordDialog"
        data-vs-textarea="observations"
      ></v-textarea>
      <zt-input
        class="mt-2"
        v-model="password"
        name="password"
        id="password"
        data-vs-input="password"
        :label="
          $t('message.LincensesApprovalPendingComponent.modal.placeholder')
        "
        type="password"
      />
    </div>
    <div class="zt-modal-footer flex justify-center items-center p-4">
      <zt-button class="mr-1 text-zt-lg" outlined @click="$emit('close')" data-vs-button="close">{{
        $t('message.LincensesApprovalPendingComponent.modal.cancelButton')
      }}</zt-button>
      <zt-button
        class="ml-1 text-zt-lg"
        @click="reject()"
        data-vs-button="reject"
        :disabled="disabled"
        >{{
          $t('message.LincensesApprovalPendingComponent.modal.okButton')
        }}</zt-button
      >
    </div>
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    request: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      licenses: Licenses,
      disabled: true,
      password: '',
      observations: '',
      someLicenseExpired: false,
      daysExpired: 0
    }
  },
  componentes: {},
  created() {
    this.licenses = new Licenses()
    let licIds = this.request.map((element) => {
      return parseInt(element.id, 10)
    })
    this.getExpired(licIds)
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser',
      getTimerSweetAlert: 'getTimerSweetAlert'
    }),
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3';
    }
  },
  methods: {
    async reject() {
      this.disabled = true
      let errors = []
      let responsePass = false;
      await this.licenses.validPass(this.password).then(async (response) => {
         responsePass = response.data.results.data[0]
      }).catch(() => {
        this.showModalInvalidPassword()
      })

      if (responsePass === true){
        for (let i = 0; i < this.request.length; i++) {
          await this.licenses
          .deleteRequestLicense(this.request[i].id, this.observations)
          .catch((error) => {
            errors.push(error)
          })
        }
        if (errors.length > 0) {
          this.disabled = false
          this.$swal({
            type: 'error',
            title:
              errors.length === 1
                ? this.$t(
                    `message.errorReference.${this.customErrorMessges(errors)}`
                  )
                : this.$t(
                    'message.LincensesApprovalPendingComponent.modal.massiveRejectError'
                  ),
            showConfirmButton: true,
            confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
          })
        } else {
          this.$swal({
            type: 'success',
            title: this.$t(
              'message.LincensesApprovalPendingComponent.modal.desapproveLicenseOk'
            ),
            timer: this.getTimerSweetAlert,
            showConfirmButton: false
          })
          this.$emit('close')
          this.$emit('refresh-table')
          this.$emit('clean-massive-array')
        }
      }
      this.disabled = false
    },
    getExpired(licIds) {
      this.licenses.getExpiredLicenses(licIds).then((res) => {
        let data = res.data.data
        for (let element in data) {
          if (data.hasOwnProperty(element)) {
            if (Object.keys(data).length === 1 && data[element].isExpired) {
              this.someLicenseExpired = true
              this.daysExpired = data[element].expireDays
              break
            }
            if (data[element].isExpired) {
              this.someLicenseExpired = true
              break
            }
          }
        }
      })
    },
    
    showModalInvalidPassword(){
      this.$swal({
          type: 'error',
          title: this.$t('message.errorReference.00042'),
          showConfirmButton: true,
          confirmButtonText: this.$t('message.settingsComponent.list.okMsg')})
    },
    customErrorMessges(error){
      const code = error[0].response.data.results.data[0] === 'La licencia no puede comenzar un dia feriado.' ? '02101' : error[0].response.data.response_v2.code;
       const message = error[0].response.data.response_v2.message
       const sichernPeopleErrorCodeRegex = /^SICHERN_PEOPLE_[A-Z_]*_ABSENCE_BAD_REQUEST$/g.test(code);
       const handledMessages = ['StatusNotAllowed','ProcessedAbsenceExists', 'AbsenceNotExists','AbsenceStatusNotValidForOperation','ErrorDeletingReviewStatus','OnlyRejectedTheLastOpeningAbsence','InvalidDateRange']
       if (sichernPeopleErrorCodeRegex && handledMessages.some(x => x == message)) {
         return `${code}_${message}`
       } else {
        return code;
       }
    },
  },
  watch: {
    password: function() {
      this.disabled = !this.password.length
    }
  }
}
</script>

<style lang="scss" scoped>
.text-iframe-primary {
  color: #2694fc !important;
}
</style>